import { Button, Group, Stack, Text } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import BlacklistsListing from "./BlacklistsListing";
import { useLanguage } from "../../../../../stores/LanguageStore";

const LeftWrapperBlacklists = () => {
  const lang = useLanguage((s) => s.language);

  return (
    <Stack pos={"relative"} flex={1}>
      <Group mt={16} miw={430}>
        <Text size="xl" fw={600}>
          {lang.prospects.tabs.blacklists}
        </Text>

        <Button
          leftSection={<IconPlus />}
          size="md"
          radius={"md"}
          fz={16}
          ml={"auto"}
          component={Link}
          to={"/blacklists/import"}
        >
          {lang.prospects.create_blacklist}
        </Button>
      </Group>

      <BlacklistsListing />
    </Stack>
  );
};

export default LeftWrapperBlacklists;
